export default "__VITE_ASSET__DeUT55e6__"